export function readSessionJson<T>(key: string, fallback: T, revive: (stored: Record<string, unknown>) => T): T {
    try {
        const raw = sessionStorage.getItem(key);
        const parsed: unknown = raw === null ? null : JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null) {
            return fallback;
        }
        return revive(parsed as Record<string, unknown>);
    } catch {
        return fallback;
    }
}

export function writeSessionJson(key: string, value: unknown): void {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
        // sessionStorage may be unavailable
    }
}
